import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export default function useNewDesign() {
  const location = useLocation();

  const hasPrintForm = useMemo(() => {
    return !!document.querySelector('.print-only');
  }, []);

  const newDesignLocations = [
    'checkin',
    'forms',
    'instant-packet',
    'documents',
    'appointments',
    'attachments'
  ];
  return hasPrintForm
    ? false
    : newDesignLocations.some((path) => location?.pathname.includes(`/${path}`));
}
